@use "~theme/typography";
@use "~components/LegacyCard/tokens" as Card;
@use "~components/Button/tokens.scss" as button-tokens;
@use "./tokens";

.page {
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  padding: {
    top: 0;
    left: tokens.$page-gutter;
    right: tokens.$page-gutter;
    bottom: tokens.$page-gutter;
  }
}

.doctorOfficeHeader {
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 16px;
}

.doctorName {
  font-weight: var(--semibold-weight);
}

.address {
  text-align: center;
}

.office {
  @include typography.caption;
}

.content {
  @include Card.border;
  background-color: var(--white);
  width: 100%;
}

.weekHeader {
  @include typography.heading4;

  align-items: center;
  background-color: var(--blue-03);
  border-bottom: 1px solid var(--blue-01-at-30);
  color: var(--blue-01);
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.weekText {
  margin: 12px;
  text-align: center;
}

.subHeadline {
  @include typography.caption;
  text-align: center;
  padding: 16px;
  border-bottom: 1px solid var(--blue-01-at-30);
}

.date {
  @include typography.heading4;
  align-items: center;
  color: var(--blue-01);
  display: flex;
  justify-content: center;
  padding-bottom: 16px;
  width: 100%;
}

.dateSlots {
  border-bottom: 1px solid var(--blue-01-at-30);
  padding: 20px;

  &:last-child {
    border-bottom: none;
  }
}

.buttonGrid {
  margin-bottom: 8px;
}

.noAvailability {
  @include typography.caption;
  display: flex;
  justify-content: center;
  color: var(--black-at-75);
  text-transform: uppercase;
  height: button-tokens.$button-standard-height;
  margin-bottom: 8px; // match slot button margin
}

.arrowButton {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 10px 20px;

  &:focus {
    box-shadow: 0 0 12px var(--highlight-blue);
  }

  &:first-child {
    border-right: 1px dashed var(--blue-01-at-30);
  }

  &:last-child {
    border-left: 1px dashed var(--blue-01-at-30);
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.viewNextWeekContainer {
  display: flex;
  padding: 24px;
  border-top: 1px solid var(--blue-01-at-30);
}

.waitlist {
  margin: 8px 12px 16px;
}
